import { render, staticRenderFns } from "./ctlQuoteDoc.vue?vue&type=template&id=4ab3fb80&"
import script from "./ctlQuoteDoc.vue?vue&type=script&lang=js&"
export * from "./ctlQuoteDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ctlQuoteDoc.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCardText,
  VDataTable,
  VDivider,
  VFlex,
  VIcon,
  VImg,
  VLayout,
  VSpacer,
})
